import React, { forwardRef } from 'react';
import { ISlidePropostaData } from '../interface';
import { SlideCapa } from './SlideCapa';
import { SlideMunicipios } from './SlideMunicipios';
import { SlideObjeto } from './SlideObjeto';
import { SlideBeneficios } from './SlideBeneficios';
import { SlideTela } from './SlideTela';
import { SlideTotem } from './SlideTotem';
import { SlideValores } from './SlideValores';
import { SlideContato } from './SlideContato';

export interface PropostaPrintDocumentProps {
  data?: ISlidePropostaData | null;
}

export const PRINT_PAGE_STYLE = `
  @page {
    size: 297mm 210mm; /* A4 Paisagem padrão */
    margin: 0mm !important;
  }
  @media print {
    *, *:before, *:after {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      width: 297mm !important;
      height: 210mm !important;
      background-color: #ffffff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .proposta-print-container {
      width: 297mm !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #ffffff !important;
    }
    .slide-print-wrapper {
      width: 297mm !important;
      height: 210mm !important;
      max-width: 297mm !important;
      max-height: 210mm !important;
      min-width: 297mm !important;
      min-height: 210mm !important;
      page-break-before: always !important;
      page-break-after: always !important;
      break-before: page !important;
      break-after: page !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      overflow: hidden !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
      position: relative !important;
      background: #ffffff !important;
    }
    .slide-print-wrapper:first-child {
      page-break-before: avoid !important;
      break-before: avoid !important;
    }
    .slide-container-root {
      width: 1920px !important;
      height: 1080px !important;
      max-width: 1920px !important;
      max-height: 1080px !important;
      transform: scale(0.584) !important;
      transform-origin: center center !important;
      margin: 0 auto !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
  }
  @media screen {
    .proposta-print-container {
      position: fixed !important;
      left: -99999px !important;
      top: 0 !important;
      width: 1920px !important;
      z-index: -9999 !important;
      pointer-events: none !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
`;

export const PropostaPrintDocument = forwardRef<HTMLDivElement, PropostaPrintDocumentProps>(
  ({ data }, ref) => {
    if (!data) return <div ref={ref} style={{ display: 'none' }} />;

    return (
      <div ref={ref} className="proposta-print-container">
        <style type="text/css">
          {PRINT_PAGE_STYLE}
        </style>

        {/* Slide 1: Capa */}
        <div className="slide-print-wrapper">
          <SlideCapa data={data} scale={1} />
        </div>

        {/* Slide 2: Institucional / 20 Municípios Ativos */}
        <div className="slide-print-wrapper">
          <SlideMunicipios data={data} scale={1} />
        </div>

        {/* Slide 3: Benefícios e Módulos */}
        <div className="slide-print-wrapper">
          <SlideBeneficios data={data} scale={1} />
        </div>

        {/* Slide 4: Objeto */}
        <div className="slide-print-wrapper">
          <SlideObjeto data={data} scale={1} />
        </div>

        {/* Slide 5: Valores e Condições de Pagamento */}
        <div className="slide-print-wrapper">
          <SlideValores data={data} scale={1} />
        </div>

        {/* Slide 6: Tela ou Totem Interativo (opcional se possuir tela) */}
        {data.possui_tela !== false && (
          <div className="slide-print-wrapper">
            {data.tipo_tela === 'totem' ? (
              <SlideTotem data={data} scale={1} />
            ) : (
              <SlideTela data={data} scale={1} />
            )}
          </div>
        )}

        {/* Slide 7: Contato */}
        <div className="slide-print-wrapper">
          <SlideContato data={data} scale={1} />
        </div>
      </div>
    );
  }
);

PropostaPrintDocument.displayName = 'PropostaPrintDocument';
export default PropostaPrintDocument;
